//
//
//
//
//
//
//
//
//
//

import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchFound',
  mixins: [searchUtils]
}
